export enum InterfaceAuthenticationType {
  CLIENTGRANT = "clientGrant",
  MTLS = "mtls",
  USERCREDENTIALS = "userCredentials",
}
